// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3MpV4","resendInfoText":"OnGoingPaymentBox_resendInfoText__1MENx"};